// Library ▸ All statistics: the project's figures, cards and the year.
export { Statistics as component } from '../../views/Statistics.tsx';
export const room = 'library';
export const page = 'statistics';
export const title = 'All statistics';
export const help = 'statistics';
